import { render, staticRenderFns } from "./SendSelectDialog.vue?vue&type=template&id=5f04d0ab&scoped=true"
import script from "./SendSelectDialog.vue?vue&type=script&lang=js"
export * from "./SendSelectDialog.vue?vue&type=script&lang=js"
import style0 from "./SendSelectDialog.vue?vue&type=style&index=0&id=5f04d0ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f04d0ab",
  null
  
)

export default component.exports